module.exports = __webpack_public_path__ + "static/media/mern.44792685.png";